<template>
    <v-flex xs12 pb-3>
        <v-toolbar height="56" color="primary">
            <v-toolbar-title class="subheading white--text">
                Propostas
            </v-toolbar-title>
        </v-toolbar>
  
        <v-card>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <span v-if="conjuntoArquivoList.length == 0">Nenhum arquivo para ser exibido</span>
                        <v-list two-line class="pa-0" id="listaDeArquivos">
                            <template v-for="(conjunto, index) in conjuntoArquivoList">
                              <div :key="conjunto.id">
                                <v-layout row wrap align-center justify-space-between> 
                                  <v-flex xs12 sm12 md3 pr-2 text-xs-left v-if="conjunto.arquivoQuestionarioUm" >
                                    <v-card  style="border: 1px solid #BABABA; border-radius: 5px;" flat>
                                      <v-card-text style="padding: 5px 10px; margin: 0;">
                                        <b>{{ conjunto.arquivoQuestionarioUm.descricao }} {{ conjunto.arquivoQuestionarioUm.tipoProposta ? ' - ' + conjunto.arquivoQuestionarioUm.tipoProposta.descricao : ' - ' + conjunto.arquivoQuestionarioUm.tipoArquivo.descricao }}</b>
                                        <br />
                                        <v-layout align-center >
                                          <v-flex xs7 style="padding-top: -5px; margin-top: -5px;">{{ toLocaleDateTimeString(conjunto.arquivoQuestionarioUm.dataCriacao) }}</v-flex>
                                          <v-flex text-xs-right xs5 style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;">
                                            <v-tooltip bottom color="blue darken-1"> 
                                              <v-btn 
                                                style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;" 
                                                slot="activator" 
                                                icon 
                                                :class="`btnDownloadArquivo-${conjunto.arquivoQuestionarioUm}`" 
                                                color="transparent" 
                                                @click.native="downloadArquivo(conjunto.arquivoQuestionarioUm)">
                                                <v-icon text-xs-right color="blue darken-1">get_app</v-icon>
                                              </v-btn>
                                              <div style="text-align: center;">Download</div>
                                            </v-tooltip>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                  </v-flex>
                                  <v-flex xs12 sm12 md3 pr-2 v-if="conjunto.arquivoQuestionarioDois">
                                    <v-card style="border: 1px solid #BABABA; border-radius: 5px;" flat>
                                      <v-card-text style="padding: 5px 10px; margin: 0;">
                                        <b>{{ conjunto.arquivoQuestionarioDois.descricao }} - {{ conjunto.arquivoQuestionarioDois.tipoProposta.descricao }}</b>
                                        <br />
                                        <v-layout align-center>
                                          <v-flex xs7 style="padding-top: -5px; margin-top: -5px;">{{ toLocaleDateTimeString(conjunto.arquivoQuestionarioDois.dataCriacao) }}</v-flex>
                                          <v-flex text-xs-right xs5 style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;">
                                            <v-tooltip bottom color="blue darken-1"> 
                                              <v-btn 
                                                style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;" 
                                                slot="activator" 
                                                icon 
                                                :class="`btnDownloadArquivo-${conjunto.arquivoQuestionarioDois.id}`" 
                                                color="transparent" @click.native="downloadArquivo(conjunto.arquivoQuestionarioDois)">
                                                <v-icon text-xs-right color="blue darken-1">get_app</v-icon>
                                              </v-btn>
                                              <div style="text-align: center;">Download</div>
                                            </v-tooltip>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                  </v-flex>
                                  <v-flex grow style="padding-left: -10px; margin-left: -10px;" v-if="conjunto.arquivoQuestionarioUm.tipoArquivo.id != arquivoHelperComputed.PROPOSTA_ASSINADA" text-xs-left>
                                    <v-tooltip bottom color="primary"> 
                                      <v-btn slot="activator" icon color="transparent" @click.native="abrirModalParecer(conjunto)">
                                        <v-icon text-xs-left medium color="primary">chat</v-icon>
                                      </v-btn>
                                      <div style="text-align: center;">Visualizar parecer do analista</div>
                                    </v-tooltip>
                                  </v-flex>
                                  <v-spacer></v-spacer>
                                  
                                  <v-flex grow order-xs5 order-md4 v-if="conjunto.conjuntoPropostaAssinada || ((permissaoAnalisaSolicitacao && conjunto.contestacao) || (conjunto.contestacao && conjunto.contestacao.id)) || podeAceitarProposta">
                                    <v-layout row wrap>
                                      <v-flex text-xs-right>
                                        <v-spacer></v-spacer>
                                        <v-btn v-if="conjunto.conjuntoPropostaAssinada" 
                                          id="btnPropostaAssinada"
                                          style="padding-left: 8pt"
                                          class="white--text"
                                          @click.native="abrirModalBaixarPropostaAssinada(conjunto)"
                                          :block="$vuetify.breakpoint.xsOnly"
                                          color="blue">
                                            <v-icon>get_app</v-icon>
                                              &nbsp;&nbsp;Proposta Assinada
                                        </v-btn>
                                        <v-btn v-if="(permissaoAnalisaSolicitacao && conjunto.contestacao) || (conjunto.contestacao && conjunto.contestacao.id)"
                                          id="btnVisualizarContestacao"
                                          class="white--text "
                                          @click.native="abrirModalContestacao(conjunto)"
                                          :block="$vuetify.breakpoint.xsOnly"
                                          color="orange">
                                              Contestação
                                        </v-btn>
                                        <v-btn v-else-if="!permissaoAnalisaSolicitacao"
                                          id="btnEnviarContestacao"
                                          class="white--text "
                                          :disabled="index != 0 || !isPropostaAguardandoCliente"
                                          :block="$vuetify.breakpoint.xsOnly"
                                          @click.native="abrirModalContestacao(conjunto)"
                                          color="orange">
                                              Contestar
                                        </v-btn>
                                        <v-btn v-if="!permissaoAnalisaSolicitacao"
                                          id="btnAceitarProposta"
                                          class="white--text"
                                          :disabled="!podeAceitarProposta || conjunto.conjuntoPropostaAssinada != null"
                                          :block="$vuetify.breakpoint.xsOnly"
                                          @click.native="abrirModalAceite(conjunto)"
                                          color="cyan darken-1">
                                              Aceitar
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>                                  
                                  <v-flex shrink xs6 md1 text-xs-right order-xs4 order-md5
                                    v-if="permissaoAnalisaSolicitacao
                                      || (conjunto.arquivoQuestionarioUm ?
                                        conjunto.arquivoQuestionarioUm.idUsuario == usuarioHelperComputed.USUARIO_LOGADO().idUsuario : false)
                                      || (conjunto.arquivoQuestionarioDois ?
                                        conjunto.arquivoQuestionarioDois.idUsuario == usuarioHelperComputed.USUARIO_LOGADO().idUsuario : false)">
                                      <v-tooltip bottom :color="visualizacaoArquivo(conjunto) ? 'grey' : 'red'">  
                                        <v-btn slot="activator" v-if="exclusaoArquivo(conjunto)" flat icon @click="abrirModalAvisoDeletarProposta(conjunto)"
                                          :disabled="visualizacaoArquivo(conjunto)">
                                          <v-icon medium color="error">delete</v-icon>
                                        </v-btn>
                                      <div style="text-align: center;" v-if="visualizacaoArquivo(conjunto)">Esta proposta não pode ser excluída<br/> porque já foi realizado o download</div>
                                      <div style="text-align: center;" v-else>Excluir</div>
                                    </v-tooltip>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-if="index+1 != conjuntoArquivoList.length">
                                  <v-divider></v-divider>
                                </v-flex>
                              </div>
                            </template>
                        </v-list>
                    </v-flex>
                    <v-flex xs12 v-if="permissaoAnalisaSolicitacao 
                         && !(model.status.id == eStatusComputed.statusEnum.RESERVA_NAO_ACEITA
                          || model.status.id == eStatusComputed.statusEnum.DIRECIONAMENTO_COMERCIAL 
                          || model.status.id == eStatusComputed.statusEnum.AGUARDANDO_EFETIVACAO
                          || model.status.id == eStatusComputed.statusEnum.SEGURO_REJEITADO 
                          || model.status.id == eStatusComputed.statusEnum.APOLICE_EM_EMISSAO
                          || model.status.id == eStatusComputed.statusEnum.EFETIVANDO_PROPOSTA
                          || model.status.id == eStatusComputed.statusEnum.ENCERRADO
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA)">
                        <v-btn
                        :block="$vuetify.breakpoint.xsOnly"
                        class="white--text right"
                        @click.native="modalUpload = true"
                        id="btnEnviarArquivo"
                        color="primary">
                            Enviar
                            <v-icon right class="hidden-sm-and-down">backup</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <!-- Modal Upload - Início -->
        <v-dialog v-model="modalUpload" max-width="500px" persistent>
          <v-card>
            <template>
              <v-card
                class="mx-auto"
                max-width="500"
              >
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; {{ currentTitle }}</span>
                </v-card-title>

                <v-window v-model="step">
                  <v-window-item :value="1">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <br>
                          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Selecione o tipo de proposta:</span>
                        </v-flex>
                      </v-layout>
                      <v-container grid-list-lg>
                        <v-form ref="formEnvioArquivo" v-model="formEnvioArquivoValid" 
                        @submit.prevent="formEnvioArquivoValid && validadeArquivosAdicionados ? step++ : step = step" 
                        enctype="multipart/form-data">
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs12 text-xs-center style="border: 2px solid #D6D6D6; border-radius: 3px; border-style: dotted;">
                              
                              <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                                <v-layout row wrap align-center justify-center v-if="!arquivoAcidente">
                                  <v-flex xs12 lg8 >
                                    <span v-if="arquivoRoubo != null && arquivoAcidente == null" class="red--text">Adicione uma proposta de acidente*</span>
                                    <v-btn :disabled="disableArquivoAcidenteMaisArquivoRoubo" block color="secondary"
                                      @click="pickFile('inputArquivoAcidente')">ACIDENTE
                                      <input id="inputArquivoAcidente" ref="inputArquivoAcidente" style="display: none"
                                        type="file"
                                        v-on:change="addArquivoAcidente()"/>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-else>
                                  <v-layout row wrap align-center align-content-center
                                    style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                    <v-flex xs9 lg10 text-xs-left >
                                      <i>{{ arquivoAcidente.nomeArquivo }}</i>
                                    </v-flex>
                                    <v-flex xs2 text-xs-right>
                                      <v-btn flat icon @click="removeArquivo('arquivoAcidente')">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>

                              <br v-if="arquivoAcidente && arquivoRoubo && permissaoAnalisaSolicitacao">

                              <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                                <v-layout align-center justify-center v-if="!arquivoRoubo">
                                  <v-flex xs12 lg8 >
                                    <v-btn :disabled="disableArquivoAcidenteMaisArquivoRoubo" block color="secondary"
                                      @click="pickFile('inputArquivoRoubo')">ROUBO
                                      <input id="inputArquivoRoubo" ref="inputArquivoRoubo" style="display: none"
                                        type="file"
                                        v-on:change="addArquivoRoubo()"/>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-else>
                                  <v-layout row wrap align-center align-content-center
                                    style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                    <v-flex xs9 lg10 text-xs-left >
                                      <i>{{ arquivoRoubo.nomeArquivo }}</i>
                                    </v-flex>
                                    <v-flex xs2 text-xs-right>
                                      <v-btn flat icon @click="removeArquivo('arquivoRoubo')">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>

                              <br v-if="arquivoRoubo && arquivoAcidenteRoubo && permissaoAnalisaSolicitacao">

                              <v-flex xs12 text-xs-center v-if="permissaoAnalisaSolicitacao">
                                <v-layout align-center justify-center v-if="!arquivoAcidenteRoubo">
                                  <v-flex xs12 lg8>
                                    <v-btn :disabled="disableAcidenteRoubo" block color="secondary"
                                      @click="pickFile('inputArquivoAcidenteRoubo')">ACIDENTE E ROUBO
                                      <input id="inputArquivoAcidenteRoubo" ref="inputArquivoAcidenteRoubo" style="display: none"
                                        type="file"
                                        v-on:change="addArquivoAcidenteRoubo()"/>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-else>
                                  <v-layout row wrap align-center align-content-center
                                    style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                    <v-flex xs9 lg10 text-xs-left >
                                      <i>{{ arquivoAcidenteRoubo.nomeArquivo }}</i>
                                    </v-flex>
                                    <v-flex xs2 text-xs-right>
                                      <v-btn flat icon @click="removeArquivo('arquivoAcidenteRoubo')">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>

                              <v-flex xs12 text-xs-center v-if="!permissaoAnalisaSolicitacao">
                                <v-layout row wrap align-center justify-center v-if="!arquivoPropostaAssinada">
                                  <v-flex xs12 lg8 >
                                    <v-btn block color="secondary"
                                      @click="pickFile('inputArquivoPropostaAssinada')">PROPOSTA ASSINADA
                                      <input id="inputArquivoPropostaAssinada" ref="inputArquivoPropostaAssinada" style="display: none"
                                        type="file"
                                        v-on:change="addArquivoPropostaAssinada()"/>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <v-flex v-else>
                                  <v-layout row wrap align-center align-content-center
                                    style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                    <v-flex xs9 lg10 text-xs-left >
                                      <i>{{ arquivoPropostaAssinada.nomeArquivo }}</i>
                                    </v-flex>
                                    <v-flex xs2 text-xs-right>
                                      <v-btn flat icon @click="removeArquivo('arquivoPropostaAssinada')">
                                        <v-icon color="red">delete</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-flex>
                            </v-flex>
                            
                            <v-flex xs12 text-xs-center>
                              <v-text-field label="Descrição"
                                id="txtDescricaoArquivo"
                                v-model="descricaoEnvio"
                                :rules="formRulesComputed.arquivo.proposta.descricao(descricaoEnvio)">
                              </v-text-field>
                            </v-flex>
                                  
                          </v-layout>
                        </v-form>                        
                      </v-container>
                    </v-card-text>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-card-text>
                      <v-form ref="formParecer" v-model="formParecerValid" @submit.prevent>
                        <v-container grid-list-lg>
                          <v-textarea
                            id="txtParecer"
                            v-model="parecerEnvio"
                            label="Insira aqui o parecer"
                            rows="7"
                            box
                            valide-on-blur
                            auto-grow
                            :rules="regras.parecer"
                          ></v-textarea>
                        </v-container>
                      </v-form>
                    </v-card-text>
                  </v-window-item>

                </v-window>

                <v-card-actions>
                  <template v-if="permissaoAnalisaSolicitacao">
                    <v-btn v-if="step === 1"
                        flat
                        id="btnFecharModal"
                        @click.native="fecharModalArquivos()" 
                        color="primary">
                            Fechar
                    </v-btn>
                    <v-btn v-else
                      color="primary"
                      flat
                      @click="step--"
                    >
                      Voltar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="step !== 2"
                      :disabled="!formEnvioArquivoValid || !validadeArquivosAdicionados"
                      color="primary"
                      depressed
                      @click="step++"
                    >
                      Avançar
                    </v-btn>
                    <v-btn v-else
                        @click.native="enviaArquivos(false)"
                        id="btnUploadArquivo"
                        :loading="enviandoArquivo"
                        :disabled="!formEnvioArquivoValid || !formParecerValid || enviandoArquivo
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA
                          || !validadeArquivosAdicionados"
                        color="primary">
                            Enviar
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                        flat
                        id="btnFecharModal"
                        @click.native="fecharModalArquivos()" 
                        color="primary">
                            Fechar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click.native="enviaArquivos(true)"
                        id="btnUploadArquivo"
                        :loading="enviandoArquivo"
                        :disabled="!formEnvioArquivoValid || enviandoArquivo
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA
                          || !validadeArquivosAdicionados"
                        color="primary">
                            Enviar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-dialog>
        <!-- Modal Excluir - Início -->
        <v-dialog v-model="modalAvisoDeletarProposta.opened" max-width="550px" persistent>
          <v-card>
            <v-card-title class="title  justify-space-between primary--text">
              <span> &nbsp; Excluir proposta</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <div> <big>{{modalAvisoDeletarProposta.message}}</big></div>
              </v-container>
            </v-card-text>
            <br>
            <v-card-actions>
              <v-btn flat 
                @click.native="fecharModalAvisoDeletarProposta()" 
                color="primary"
                :loading="modalAvisoDeletarProposta.processando"
                :disabled="modalAvisoDeletarProposta.processando"
                id="btnFecharModalAvisoDeletarProposta">Fechar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn id="btnConfirmaExclusao"
                color="primary"
                :loading="modalAvisoDeletarProposta.processando"
                :disabled="modalAvisoDeletarProposta.processando"
                @click="removerProposta(modalAvisoDeletarProposta.propostaEmExclusao)">Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Modal Parecer - Início -->
        <v-dialog v-model="modalParecer.opened" max-width="500px" persistent>
          <v-card>
            <v-card-title class="title  justify-space-between primary--text">
              <span> &nbsp; Parecer do Analista</span>
            </v-card-title>
            <v-card-text>
              <v-container >
                <v-textarea style="font-size: 13pt;"
                  id="txtParecerExibicao"
                  box
                  hide-details
                  readonly
                  flat
                  :value="modalParecer.parecer"
                  auto-grow
                ></v-textarea>
              </v-container>
            </v-card-text>
            <br>
            <v-card-actions>
              <v-btn flat 
                @click.native="fecharModalParecer()" 
                color="primary"
                :loading="modalParecer.processando"
                :disabled="modalParecer.processando"
                id="btnFecharModalParecer">Fechar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn id="btnCopiarParecer"
                color="primary"
                :loading="modalParecer.processando"
                :disabled="modalParecer.processando"
                @click="copiar('#txtParecerExibicao')">Copiar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Modal Contestação - Início -->
        <v-dialog v-model="modalContestacao.opened" max-width="500px" persistent>
          <v-card>
            <template>
              <v-card
                class="mx-auto"
                max-width="500"
              >
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; Contestação de Proposta</span>
                </v-card-title>
                <v-card-text>
                  <v-form ref="formContestacao" v-model="formContestacaoValid" @submit.prevent>
                    <v-container grid-list-lg>
                      <v-textarea v-if="permissaoAnalisaSolicitacao || modalContestacao.contestacao.id"
                      id="txtContestacaoExibicao"
                        box
                        hide-details
                        readonly
                        flat
                        :value="modalContestacao.contestacao.descricao"
                        auto-grow
                      ></v-textarea>
                      <v-textarea v-else
                        style="font-size: 13pt;"
                        id="txtContestacaoPreenchimento"
                        v-model="modalContestacao.contestacao.descricao"
                        label="Insira aqui a sua contestação"
                        rows="7"
                        box
                        valide-on-blur
                        auto-grow
                        required
                      ></v-textarea>                      
                    </v-container>
                  </v-form>
                </v-card-text>
                <br>
                <v-card-actions>
                  <v-btn flat 
                    @click.native="fecharModalContestacao()" 
                    color="primary"
                    :loading="modalContestacao.processando"
                    :disabled="modalContestacao.processando"
                    id="btnFecharModalContestacao">
                      {{ permissaoAnalisaSolicitacao || modalContestacao.contestacao.id ? 'Fechar' : 'Cancelar' }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if="permissaoAnalisaSolicitacao || modalContestacao.contestacao.id"
                    id="btnCopiarContestacao"
                    color="primary"
                    :loading="modalContestacao.processando"
                    :disabled="modalContestacao.processando"
                    @click="copiar('#txtContestacaoExibicao')">Copiar
                  </v-btn>
                  <v-btn v-else
                    id="btnEnviarContestacao"
                    color="primary"
                    :loading="modalContestacao.processando"
                    :disabled="!modalContestacao.contestacao.descricao || modalContestacao.processando"
                    @click="enviarContestacao()">Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-dialog>
        <!-- Modal Aceite - Início -->
        <v-dialog v-model="modalAceite.opened" max-width="500px" persistent>
          <v-card>
            <template>
              <v-card
                class="mx-auto"
                max-width="500"
              >
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; Aceitar Proposta</span>
                </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <br>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Obrigatório anexar a proposta assinada:</span>
                      </v-flex>
                    </v-layout>
                    <v-container grid-list-lg>
                      <v-form ref="formEnvioArquivo" v-model="formEnvioPropostaAssinadaValid" 
                      @submit.prevent="formEnvioPropostaAssinadaValid" 
                      enctype="multipart/form-data">
                        <v-layout row wrap align-center justify-center>
                          <v-flex xs12 text-xs-center style="border: 2px solid #D6D6D6; border-radius: 3px; border-style: dotted;">
                            
                            <v-flex xs12 text-xs-center 
                              v-if="!permissaoAnalisaSolicitacao 
                                    && (modalAceite.proposta 
                                    && (modalAceite.proposta.arquivoQuestionarioUm.tipoProposta.id == tipoPropostaComputed.ACIDENTE
                                    || (modalAceite.proposta.arquivoQuestionarioDois && modalAceite.proposta.arquivoQuestionariodois.tipoProposta.id == tipoPropostaComputed.ACIDENTE)))">
                              <v-layout row wrap align-center justify-center v-if="!arquivoAcidente">
                                <v-flex xs12 lg8 >
                                  <span v-if="arquivoRoubo != null && arquivoAcidente == null" class="red--text">Adicione uma proposta de acidente*</span>
                                  <v-btn :disabled="disableArquivoAcidenteMaisArquivoRoubo" block color="secondary"
                                    @click="pickFile('inputArquivoAcidente')">ACIDENTE
                                    <input id="inputArquivoAcidente" ref="inputArquivoAcidente" style="display: none"
                                      type="file"
                                      v-on:change="addArquivoAcidente()"/>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-flex v-else>
                                <v-layout row wrap align-center align-content-center
                                  style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                  <v-flex xs9 lg10 text-xs-left >
                                    <i>{{ arquivoAcidente.nomeArquivo }}</i>
                                  </v-flex>
                                  <v-flex xs2 text-xs-right>
                                    <v-btn flat icon @click="removeArquivo('arquivoAcidente')">
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>

                            <br v-if="arquivoAcidente && arquivoRoubo && permissaoAnalisaSolicitacao">

                            <v-flex xs12 text-xs-center 
                              v-if="!permissaoAnalisaSolicitacao
                              && (modalAceite.proposta 
                              && (modalAceite.proposta.arquivoQuestionarioUm.tipoProposta.id == tipoPropostaComputed.ROUBO 
                              || (modalAceite.proposta.arquivoQuestionarioDois && modalAceite.proposta.arquivoQuestionarioDois.tipoProposta.id == tipoPropostaComputed.ROUBO)))">
                              <v-layout align-center justify-center v-if="!arquivoRoubo">
                                <v-flex xs12 lg8>
                                  <v-btn :disabled=" disableArquivoAcidenteMaisArquivoRoubo || modalAceite.chkRecusarPropostaRouboValue" block color="secondary"
                                    @click="pickFile('inputArquivoRoubo')">ROUBO
                                    <input id="inputArquivoRoubo" ref="inputArquivoRoubo" style="display: none"
                                      type="file"
                                      v-on:change="addArquivoRoubo()"/>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-flex v-else>
                                <v-layout row wrap align-center align-content-center
                                  style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                  <v-flex xs9 lg10 text-xs-left >
                                    <i>{{ arquivoRoubo.nomeArquivo }}</i>
                                  </v-flex>
                                  <v-flex xs2 text-xs-right>
                                    <v-btn flat icon @click="removeArquivo('arquivoRoubo')">
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>

                            <br v-if="arquivoRoubo && arquivoAcidenteRoubo && permissaoAnalisaSolicitacao">

                            <v-flex xs12 text-xs-center 
                              v-if="!permissaoAnalisaSolicitacao
                              && (modalAceite.proposta && modalAceite.proposta.arquivoQuestionarioUm.tipoProposta.id == tipoPropostaComputed.ACIDENTE_E_ROUBO)">
                              <v-layout align-center justify-center v-if="!arquivoAcidenteRoubo">
                                <v-flex xs12 lg8>
                                  <v-btn :disabled="disableAcidenteRoubo" block color="secondary"
                                    @click="pickFile('inputArquivoAcidenteRoubo')">ACIDENTE E ROUBO
                                    <input id="inputArquivoAcidenteRoubo" ref="inputArquivoAcidenteRoubo" style="display: none"
                                      type="file"
                                      v-on:change="addArquivoAcidenteRoubo()"/>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-flex v-else>
                                <v-layout row wrap align-center align-content-center
                                  style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                  <v-flex xs9 lg10 text-xs-left >
                                    <i>{{ arquivoAcidenteRoubo.nomeArquivo }}</i>
                                  </v-flex>
                                  <v-flex xs2 text-xs-right>
                                    <v-btn flat icon @click="removeArquivo('arquivoAcidenteRoubo')">
                                      <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>

                          </v-flex>

                          <v-flex xs12 text-xs-center 
                            v-if="!arquivoRoubo 
                              && !(modalAceite.proposta && modalAceite.proposta.arquivoQuestionarioUm.tipoProposta.id == tipoPropostaComputed.ACIDENTE_E_ROUBO)
                              && (modalAceite.proposta 
                                  && (modalAceite.proposta.arquivoQuestionarioUm.tipoProposta.id == tipoPropostaComputed.ROUBO 
                                  || (modalAceite.proposta.arquivoQuestionarioDois && modalAceite.proposta.arquivoQuestionarioDois.tipoProposta.id == tipoPropostaComputed.ROUBO)))">
                            <v-checkbox
                              id="chkRecusarPropostaRoubo"
                              color="primary"
                              v-model="modalAceite.chkRecusarPropostaRouboValue"
                              :disabled="arquivoRoubo"
                              label="Recusar Proposta de Seguro de Roubo"
                            ></v-checkbox>
                            <!-- <v-text-field v-if="modalAceite.chkRecusarPropostaRouboValue"
                              label="Motivo"
                              id="txtMotivoArquivo"
                              v-model="descricaoEnvio"
                              :rules="formRulesComputed.arquivo.proposta.descricao(descricaoEnvio)"
                              required>
                            </v-text-field>
                            -->
                          </v-flex>
                        </v-layout>
                      </v-form>
                      <br>
                      <v-flex xs12 sm8>
                        <v-menu
                          id="datePickerPropostaAssinadaMenu"
                          ref="datePickerPropostaAssinadaMenu"
                          lazy
                          :close-on-content-click="false"
                          v-model="modalAceite.datePicker.opened"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-left="40"
                          max-width="290px"
                        >
                          <v-text-field
                            id="datePickerPropostaAssinadaTextField"
                            ref="datePickerPropostaAssinadaTextField"
                            slot="activator"
                            label="Inicio de Vigência Desejado*"
                            v-model="modalAceite.datePicker.dataVigenciaDesejadaFormatted"
                            prepend-icon="event"
                            :rules="formRulesComputed.arquivo.propostaAssinada.dataVigenciaDesejada(modalAceite.datePicker.dataVigenciaDesejada)"
                            required
                            validate-on-blur
                          ></v-text-field>
                          <v-date-picker
                            id="datePickerPropostaAssinadaComponent"
                            ref="datePickerPropostaAssinadaComponent"
                            @input="$refs.datePickerPropostaAssinadaMenu.save(modalAceite.datePicker.dataVigenciaDesejada)"
                            locale="pt-br"
                            v-model="modalAceite.datePicker.dataVigenciaDesejada"
                            :min="(new Date()).toISOString().substring(0, 10)"
                            no-title
                            scrollable
                            actions>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-container>
                  </v-card-text>
                <v-card-actions>
                  <v-btn flat 
                    @click.native="fecharModalAceite()" 
                    color="primary"
                    :loading="modalAceite.processando"
                    :disabled="modalAceite.processando"
                    id="btnFecharModalAceite">
                      Fechar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    id="btnEnviarAceite"
                    color="primary"
                    :loading="modalAceite.processando"
                    :disabled="!formEnvioPropostaAssinadaValid || enviandoArquivo
                          || model.status.id == eStatusComputed.statusEnum.PROPOSTA_EXPIRADA
                          || !validadePropostasAssinadasAdicionados || modalAceite.processando
                          || !modalAceite.datePicker.dataVigenciaDesejada"
                    @click="enviaArquivos(true)">Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-dialog>
        <!-- Modal Baixar Proposta Assinada - Início -->
        <v-dialog v-model="modalBaixarPropostaAssinada.opened" max-width="500px" persistent>
          <v-card>
            <template>
              <v-card
                class="mx-auto"
                max-width="500"
              >
                <v-card-title class="title  justify-space-between primary--text">
                  <span>&nbsp; Proposta Assinada </span>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <br>
                      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Arquivos anexados:</span>
                    </v-flex>
                  </v-layout>
                  <v-container grid-list-lg>
                   
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs12 text-xs-center style="border: 2px solid #D6D6D6; border-radius: 3px; border-style: dotted;">
                          
                          <v-flex xs12 text-xs-center v-if="propostaAssinadaAcidente">
                            <v-flex>
                              <v-layout row wrap align-center align-content-center
                                style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                <v-flex xs9 lg10 text-xs-left >
                                  <i>{{ propostaAssinadaAcidente.nomeArquivo }}</i>
                                </v-flex>
                                <v-flex xs2 text-xs-right>
                                  <v-btn flat icon @click.native="downloadArquivo(propostaAssinadaAcidente)">
                                    <v-icon color="blue">get_app</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>

                          <br v-if="propostaAssinadaAcidente && propostaAssinadaRoubo">

                          <v-flex xs12 text-xs-center v-if="propostaAssinadaRoubo">
                            <v-flex>
                              <v-layout row wrap align-center align-content-center
                                style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                <v-flex xs9 lg10 text-xs-left >
                                  <i>{{ propostaAssinadaRoubo.nomeArquivo }}</i>
                                </v-flex>
                                <v-flex xs2 text-xs-right>
                                  <v-btn flat icon @click.native="downloadArquivo(propostaAssinadaRoubo)">
                                    <v-icon color="blue">get_app</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>

                          <v-flex xs12 text-xs-center 
                            v-if="!propostaAssinadaRoubo 
                                  && (modalBaixarPropostaAssinada.proposta 
                                      && modalBaixarPropostaAssinada.proposta.arquivoQuestionarioDois != null)">
                            <v-flex>
                              <v-layout row wrap align-center align-content-center
                                style="max-height: 45px;">
                                <v-flex xs9 lg10 text-xs-left >
                                  <div class="red--text">Proposta de Seguro de Roubo recusada.</div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>

                          <br v-if="propostaAssinadaRoubo && propostaAssinadaAcidenteRoubo">

                          <v-flex xs12 text-xs-center v-if="propostaAssinadaAcidenteRoubo">
                            <v-flex>
                              <v-layout row wrap align-center align-content-center
                                style="border: 2px solid #E5E5E5; border-radius: 3px; background-color: #E5E5E5; max-height: 45px;">
                                <v-flex xs9 lg10 text-xs-left >
                                  <i>{{ propostaAssinadaAcidenteRoubo.nomeArquivo }}</i>
                                </v-flex>
                                <v-flex xs2 text-xs-right>
                                  <v-btn flat icon @click.native="downloadArquivo(propostaAssinadaAcidenteRoubo)">
                                    <v-icon color="blue">get_app</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>
                      
                        </v-flex>
                              
                      </v-layout>                        
                  </v-container>
                  <v-layout row wrap v-if="permissaoAnalisaSolicitacao">
                    <v-flex xs12>
                      <br>
                      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data esperada de início da vigência: {{dataVigenciaDesejadaPropostaAssinada}}</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <br>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat 
                    @click.native="fecharModalBaixarPropostaAssinada()" 
                    color="primary"
                    :loading="modalBaixarPropostaAssinada.processando"
                    :disabled="modalBaixarPropostaAssinada.processando"
                    id="btnFecharModalBaixarPropostaAssinada">
                      Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-card>
        </v-dialog>

        <v-dialog v-model="modalCienciaDeAceitePropostaAssinada.opened" max-width="550px" persistent>
          <v-card>
            <v-card-title class="title  justify-space-between primary--text">
              <span> &nbsp; O aceite da proposta foi enviado.</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <div> <big>{{modalCienciaDeAceitePropostaAssinada.message}}</big></div>
              </v-container>
            </v-card-text>
            <br>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="btnConfirmaCienciaAceiteProposta"
                color="primary"
                :loading="modalCienciaDeAceitePropostaAssinada.processando"
                :disabled="modalCienciaDeAceitePropostaAssinada.processando"
                @click="enviarConfirmacaoDeCienciaAceiteProposta()">ESTOU CIENTE
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
            id="snackMensagemEnvio"
            :timeout="6000"
            :color="snackbar.sucesso ? 'success' : 'error'"
            multi-line
            v-model="snackbar.visivel">
            {{ snackbar.mensagem }}
            <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
        </v-snackbar>
    </v-flex>
</template>

<script>
import axios from 'axios';
import arquivoHelper from '@/helpers/arquivo-helper';
import tipoProposta from '@/helpers/tipo-proposta';
import perfil from '@/helpers/perfil';
import CustomFormat from '@/helpers/custom-format';
import formRules from '@/helpers/form-rules';
import permissoes from '@/helpers/permissoes';
import estatus from '@/helpers/estatus';
import usuarioHelper from '@/helpers/usuario-logado';
import arquivoFunctions from '@/components/pages/solicitacao-consulta/ArquivoFunctions'

export default {
  name: 'arquivospropostas',
  props: ["model"],
  data() {
    return {
      step: 1,
      regras: {
        parecer: [v => !!v || 'Você não pode deixar este campo em branco']
      },
      snackbar: {
        sucesso: false,
        mensagem: '',
        visivel: false
      },
      modalUpload: false,
      modalAvisoDeletarProposta: {
        opened: false,
        message: '',
        propostaEmExclusao: null,
        processando: false
      },
      modalParecer: {
        opened: false,
        parecer: '',
        proposta: null,
        processando: false
      },
      modalContestacao: {
        opened: false,
        contestacao: {
          id: 0,
          idQuestionario: 0,
          status: null,
          descricao: '',
          nomeUsuarioAutor: ''
        },
        proposta: null,
        processando: false
      },
      modalAceite: {
        opened: false,
        proposta: null,
        processando: false,
        chkRecusarPropostaRouboValue: false,
        datePicker: {
          opened: false,
          dataVigenciaDesejada: null,
          dataVigenciaDesejadaFormatted: null
        }
      },
      modalBaixarPropostaAssinada: {
        opened: false,
        proposta: null,
        processando: false
      },
      modalCienciaDeAceitePropostaAssinada: {
        opened: false,
        conjuntoPropostaAssinada: null,
        message: '',
        processando: false
      },
      formEnvioArquivoValid: false,
      formEnvioPropostaAssinadaValid: false,
      formParecerValid: false,
      formContestacaoValid: false,
      formAceiteValid: false,
      arquivoAcidente: null,
      arquivoAcidenteRoubo: null,
      arquivoRoubo: null,
      propostaAssinadaAcidente: null,
      propostaAssinadaAcidenteRoubo: null,
      propostaAssinadaRoubo: null,
      arquivoPropostaAssinada: null,
      descricaoEnvio: '',
      parecerEnvio: '',
      arquivoModel: {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false,
        tipoProposta: {},
        arquivo: null
      },
      conjuntoArquivoModel: {
        id: null,
        parecer: null,
        arquivoQuestionarioUm: null,
        arquivoQuestionarioDois: null,
        idQuestionario: 0,
        excluido: false,
      },
      enviandoArquivo: false,
      conjuntoArquivoList: [],
      urlEnviaProposta: `${process.env.URL_QUESTIONARIOMS}/v1/enviaConjuntoArquivo`,
      urlEnviaPropostaAssinada: `${process.env.URL_QUESTIONARIOMS}/v1/aceitaProposta`,
    }
  },
  computed: {
    currentTitle () {
        switch (this.step) {
          case 1: return 'Upload de Propostas'
          case 2: return 'Parecer'
          default: return 'Enviado'
        }
    },
    permissaoAnalisaSolicitacao: function() {
      return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
    },
    usuarioHelperComputed: function () {
      return usuarioHelper;
    },
    arquivoHelperComputed: function () {
      return arquivoHelper;
    },
    eStatusComputed: function () {
      return estatus;
    },
    perfilComputed: function () {
      return perfil;
    },
    tipoPropostaComputed: function () {
      return tipoProposta;
    },
    formRulesComputed: function() {
      return formRules;
    },
    tiposArquivos: function () {
      if (permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)) {
        return [ { id: 1, descricao: 'Proposta' } ];
      } else {
        return [ { id: 4, descricao: 'Proposta Assinada' } ];
      }
    },
    disableArquivoAcidenteMaisArquivoRoubo: function() {
      return this.arquivoAcidenteRoubo != null;
    },
    disableAcidenteRoubo: function() {
      const self = this;
      return self.arquivoAcidente != null || self.arquivoRoubo != null;
    },
    validadeArquivosAdicionados: function() {
      const self = this;
      if  (   (self.arquivoRoubo != null && self.arquivoAcidente == null)
          ||  (self.arquivoAcidenteRoubo != null && (self.arquivoRoubo != null || self.arquivoAcidente != null))
          ||  (!self.arquivoAcidente && !self.arquivoRoubo && !self.arquivoAcidenteRoubo && !self.arquivoPropostaAssinada)
          ||  (self.arquivoPropostaAssinada && (self.arquivoAcidente || self.arquivoRoubo || self.arquivoAcidenteRoubo))) {
        return false;
      }
      return true;
    },
    validadePropostasAssinadasAdicionados: function() {
      const self = this;
      if  (   self.modalAceite.proposta &&
            ((self.arquivoRoubo != null && self.arquivoAcidente == null)
            ||  (self.arquivoAcidente != null && self.modalAceite.proposta.arquivoQuestionarioDois && self.arquivoRoubo == null && self.modalAceite.chkRecusarPropostaRouboValue == false)
            ||  (self.arquivoAcidenteRoubo != null && (self.arquivoRoubo != null || self.arquivoAcidente != null))
            ||  (!self.arquivoAcidente && !self.arquivoRoubo && !self.arquivoAcidenteRoubo))) {
        return false;
      }
      return true;
    },
    isPropostaContestada: function () {
      const self = this;
      return self.model.status.id == estatus.statusEnum.PROPOSTA_CONTESTADA;
    },
    isPropostaAguardandoCliente: function () {
      const self = this;
      return self.model.status.id == estatus.statusEnum.AGUARDANDO_CLIENTE;
    },
    podeAceitarProposta: function () {
      const self = this;
      return self.model.status.id == estatus.statusEnum.AGUARDANDO_CLIENTE
            || self.model.status.id == estatus.statusEnum.PROPOSTA_CONTESTADA;
    },
    podeContestarProposta: function () {
      const self = this;
      return self.model.status.id == estatus.statusEnum.AGUARDANDO_CLIENTE
            || self.model.status.id == estatus.statusEnum.PROPOSTA_CONTESTADA;
    },
    dataVigenciaDesejadaPropostaAssinada: function() {
      const self = this;
      if (self.modalBaixarPropostaAssinada.proposta) {
        return CustomFormat.parseDateToFormatedString(self.modalBaixarPropostaAssinada.proposta.conjuntoPropostaAssinada.dataVigenciaDesejada);
      }
      return '';
    }
  },
  watch: {
    'modalAceite.datePicker.dataVigenciaDesejada': function(value) {
      const self = this;
      if (self.modalAceite.datePicker.dataVigenciaDesejada) {
        self.modalAceite.datePicker.dataVigenciaDesejadaFormatted = CustomFormat.parseDateToFormatedString(value);
      }
    }
  },
  mounted: function () {
    this.carregaArquivos();
  },
  methods: {
    pickFile: function(ref) {
      eval('this.$refs.' + ref + '.click()');
    },
    visualizacaoArquivo: function (conjuntoarquivo) {
      let arquivoUmVisualizado = false;
      let arquivoDoisVisualizado = false;
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ANALISTA) {
        if(conjuntoarquivo.arquivoQuestionarioUm)
          arquivoUmVisualizado = conjuntoarquivo.arquivoQuestionarioUm.visualizacaoCliente ? true : false;
        if(conjuntoarquivo.arquivoQuestionarioDois)
          arquivoDoisVisualizado = conjuntoarquivo.arquivoQuestionarioDois.visualizacaoCliente ? true : false;
      }
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.CLIENTE || usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL) {
        if(conjuntoarquivo.arquivoQuestionarioUm)
          arquivoUmVisualizado = conjuntoarquivo.arquivoQuestionarioUm.visualizacaoAnalista ? true : false;
        if(conjuntoarquivo.arquivoQuestionarioDois)
          arquivoDoisVisualizado = conjuntoarquivo.arquivoQuestionarioDois.visualizacaoAnalista ? true : false;
      }
      return arquivoUmVisualizado || arquivoDoisVisualizado;
    },
    exclusaoArquivo: function (conjuntoarquivo) {
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ADMINISTRADOR) {
          return true
      }
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ANALISTA) {
          return conjuntoarquivo.arquivoQuestionarioUm.tipoArquivo.id == arquivoHelper.PROPOSTA_ASSINADA ? false : true;
      }
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.CLIENTE || usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL) {
          return conjuntoarquivo.arquivoQuestionarioUm.tipoArquivo.id == arquivoHelper.PROPOSTA_ASSINADA ? true : false;
      }
    },
    addArquivoAcidente: function() {
      const self = this;
      const fileInput = self.$refs.inputArquivoAcidente.files[0];
      
      self.arquivoModel.nomeArquivo = fileInput.name;
      if(self.permissaoAnalisaSolicitacao) {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      }      
      self.arquivoModel.idQuestionario = self.model.id;
      self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      self.arquivoModel.mimeType = fileInput.type;
      self.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ACIDENTE;

      self.arquivoAcidente = JSON.parse(JSON.stringify(self.arquivoModel));
      self.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          self.arquivoAcidente.arquivo = response;
        } else {
          self.arquivoAcidente = null;
        }
      });

      self.resetArquivoModel();
    },
    addArquivoRoubo: function() {
      const self = this;
      const fileInput = self.$refs.inputArquivoRoubo.files[0];
      
      self.arquivoModel.nomeArquivo = fileInput.name;
      if(self.permissaoAnalisaSolicitacao) {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      } 
      self.arquivoModel.idQuestionario = self.model.id;
      self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      self.arquivoModel.mimeType = fileInput.type;
      self.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ROUBO;

      self.arquivoRoubo = JSON.parse(JSON.stringify(self.arquivoModel));
      self.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          self.arquivoRoubo.arquivo = response;
        } else {
          self.arquivoRoubo = null;
        }
      });

      self.resetArquivoModel();
    },
    addArquivoAcidenteRoubo: function() {
      const self = this;
      const fileInput = self.$refs.inputArquivoAcidenteRoubo.files[0];
      
      self.arquivoModel.nomeArquivo = fileInput.name;
      if(self.permissaoAnalisaSolicitacao) {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA;
      } else {
        self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      } 
      self.arquivoModel.idQuestionario = self.model.id;
      self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      self.arquivoModel.mimeType = fileInput.type;
      self.arquivoModel.tipoProposta = arquivoFunctions.tipoProposta.ACIDENTE_ROUBO;

      self.arquivoAcidenteRoubo = JSON.parse(JSON.stringify(self.arquivoModel));
      self.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          self.arquivoAcidenteRoubo.arquivo = response;
        } else {
          self.arquivoAcidenteRoubo = null;
        }
      });

      self.resetArquivoModel();
    },
    addArquivoPropostaAssinada: function() {
      const self = this;
      const fileInput = self.$refs.inputArquivoPropostaAssinada.files[0];
      
      self.arquivoModel.nomeArquivo = fileInput.name;
      self.arquivoModel.tipoArquivo = arquivoFunctions.tipoArquivo.PROPOSTA_ASSINADA;
      self.arquivoModel.idQuestionario = self.model.id;
      self.arquivoModel.tokenUsuario = usuarioHelper.USUARIO_LOGADO().token;
      self.arquivoModel.mimeType = fileInput.type;
      self.arquivoModel.tipoProposta = null;

      self.arquivoPropostaAssinada = JSON.parse(JSON.stringify(self.arquivoModel));
      self.arquivoParaByteArray(fileInput).then((response) => {
        if (response) {
          self.arquivoPropostaAssinada.arquivo = response;
        } else {
          self.arquivoPropostaAssinada = null;
        }
      });

      self.resetArquivoModel();
    },
    removeArquivo: function(tipoArquivo) {
      const self = this;
      eval('this.' + tipoArquivo + ' = null;');
    },
    enviaArquivos: function(propostaAssinada) {
      const self = this;
      self.enviandoArquivo = true;
      self.$store.commit('startLoading');

      var arquivoList = [];
      var formData = new FormData();
      var url = null;

      if (self.arquivoAcidente) {
        self.arquivoAcidente.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoAcidente);
      }
      if (self.arquivoRoubo) {
        self.arquivoRoubo.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoRoubo);
      }
      if (self.arquivoAcidenteRoubo) {
        self.arquivoAcidenteRoubo.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoAcidenteRoubo);
      }
      if (self.arquivoPropostaAssinada) {
        self.arquivoPropostaAssinada.descricao = self.descricaoEnvio || 'Sem descrição';
        arquivoList.push(self.arquivoPropostaAssinada);
      }

      formData.append('arquivoList', JSON.stringify(arquivoList));
      formData.append('parecer', self.parecerEnvio);
      formData.append('idConjuntoArquivo', self.modalAceite.proposta ? self.modalAceite.proposta.id : null);
      formData.append('transportadoraNome', self.$parent.transportadoraModel.nome);
      formData.append('usuarioPerfil', usuarioHelper.USUARIO_LOGADO().perfil.id);
      formData.append('usuarioNome', usuarioHelper.USUARIO_LOGADO().nome);

      if (propostaAssinada) {
        formData.append('dataVigenciaDesejada', self.modalAceite.datePicker.dataVigenciaDesejada);
        url = self.urlEnviaPropostaAssinada;
      } else {
        url = self.urlEnviaProposta;
      }
   
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`);

      xhr.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          self.carregaArquivos();
          self.$parent.carregaQuestionario();

          self.snackbar.visivel = true;
          self.snackbar.sucesso = true;
          self.snackbar.mensagem = 'Arquivo enviado com sucesso.';

          if(propostaAssinada) {
            self.fecharModalAceite();
            self.modalCienciaDeAceitePropostaAssinada.conjuntoPropostaAssinada = JSON.parse(this.response);
            self.modalCienciaDeAceitePropostaAssinada.message = 'O seguro ainda não foi efetivado, é necessário aguardar a confirmação da cobertura.';
            self.modalCienciaDeAceitePropostaAssinada.opened = true;
          } else {
            self.fecharModalArquivos();
            self.step = 1;
          }
        } else {
          if(propostaAssinada) {
            self.fecharModalAceite();
          }
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = JSON.parse(this.response).message;
          self.snackbar.visivel = true;
        }
        self.$store.commit('endLoading');
        self.enviandoArquivo = false;
      };

      xhr.send(formData);
    },
    removerProposta: function(conjuntoProposta) {
      const self = this;
      self.$store.commit('startLoading');
      axios.delete(`${process.env.URL_QUESTIONARIOMS}/v1/deletaConjuntoArquivo?idConjuntoArquivo=${conjuntoProposta.id}&nomeUsuarioLogado=${usuarioHelper.USUARIO_LOGADO().nome}&nomeTransportadora=${self.$parent.transportadoraModel.nome}`,
          { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        if (response) {
          self.carregaArquivos();
        }
        self.snackbar.sucesso = response.data;
        self.snackbar.mensagem = response.data ? 'Proposta excluída com sucesso.' : 'Houve um problema ao excluir a proposta.';
        self.snackbar.visivel = true;

        self.fecharModalAvisoDeletarProposta();
        self.modalAvisoDeletarProposta.processando = false;
        self.$store.commit('endLoading');
      })
      .catch((error) => {
        self.snackbar.mensagem = error.response.data.message;
        self.snackbar.sucesso = false;
        self.snackbar.visivel = true;
        self.modalAvisoDeletarProposta.processando = false;
        self.$store.commit('endLoading');
      });
    },
    abrirModalAvisoDeletarProposta: function(conjuntoProposta) {
      const self = this;
      self.modalAvisoDeletarProposta.message = 'Deseja excluir a proposta ' + conjuntoProposta.arquivoQuestionarioUm.descricao + '?';
      self.modalAvisoDeletarProposta.opened = true;
      self.modalAvisoDeletarProposta.propostaEmExclusao = conjuntoProposta;
    },
    fecharModalAvisoDeletarProposta: function() {
        const self = this;
        self.modalAvisoDeletarProposta.message = '';
        self.modalAvisoDeletarProposta.opened = false;
        self.modalAvisoDeletarProposta.propostaEmExclusao = null;
        self.modalAvisoDeletarProposta.processando = false;
    },
    abrirModalParecer: function (conjuntoProposta) {
      const self = this;
      self.modalParecer.parecer = conjuntoProposta.parecer.descricao;
      self.modalParecer.opened = true;
      self.modalParecer.proposta = conjuntoProposta;
    },
    fecharModalParecer: function() {
        const self = this;
        self.modalParecer.parecer = '';
        self.modalParecer.opened = false;
        self.modalParecer.proposta = null;
        self.modalParecer.processando = false;
    },
    abrirModalContestacao: function (conjuntoProposta) {
      const self = this;
      if (self.fezDownloadDaProposta(conjuntoProposta)) {
        if(conjuntoProposta.contestacao && conjuntoProposta.contestacao.id != 0) {
          self.modalContestacao.contestacao = Object.assign({}, conjuntoProposta.contestacao);
        } else {
          self.modalContestacao.contestacao.descricao = '';
        }
        self.modalContestacao.opened = true;
        self.modalContestacao.proposta = conjuntoProposta;
      }
    },
    fecharModalContestacao: function () {
      const self = this;
      self.modalContestacao.contestacao.descricao = '';
      self.modalContestacao.contestacao = {
          id: 0,
          idQuestionario: 0,
          status: null,
          descricao: '',
          nomeUsuarioAutor: ''
        };
      self.modalContestacao.opened = false;
      self.modalContestacao.proposta = null;
      self.modalContestacao.processando = false;
    },
    enviarContestacao: function () {
      const self = this;
      if(self.modalContestacao.contestacao.descricao) {
        let proposta = self.modalContestacao.proposta;
        proposta.contestacao = {}
        proposta.contestacao.descricao = self.modalContestacao.contestacao.descricao;
        self.$store.commit('startLoading');
        axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/contestaProposta`, proposta,
          { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
        .then((response) => {
          if (response) {
            self.carregaArquivos();
            self.$parent.carregaQuestionario();
          }
          self.snackbar.sucesso = response.data;
          self.snackbar.mensagem = response.data ? 'Contestação enviada com sucesso.' : 'Houve um problema ao contestar a proposta.';
          self.snackbar.visivel = true;

          self.fecharModalContestacao();
          self.modalContestacao.processando = false;
          self.$store.commit('endLoading');
        })
        .catch((error) => {
          proposta.contestacao.descricao = null;
          self.snackbar.mensagem = error.response.data.message;
          self.snackbar.sucesso = false;
          self.snackbar.visivel = true;
          self.fecharModalContestacao();
          self.modalContestacao.processando = false;
          self.$store.commit('endLoading');
        });

      }      
    },
    enviarConfirmacaoDeCienciaAceiteProposta: function() {
      const self = this;
      self.modalCienciaDeAceitePropostaAssinada.processando = true;
      axios.put(`${process.env.URL_QUESTIONARIOMS}/v1/arquivos/propostas-assinadas/confirmacao-ciencia-cliente`, self.modalCienciaDeAceitePropostaAssinada.conjuntoPropostaAssinada,
        { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        self.fecharModalCienciaDeAceitePropostaAssinada();
      })
      .catch((error) => {
          self.snackbar.mensagem = 'Erro ao confirmar ciência.';
          self.snackbar.sucesso = false;
          self.snackbar.visivel = true;
          self.modalCienciaDeAceitePropostaAssinada.processando = false;
        });
    },
    abrirModalAceite(conjuntoProposta) {
      const self = this;
      if (self.fezDownloadDaProposta(conjuntoProposta)) {
        self.modalAceite.opened = true;
        self.modalAceite.proposta = conjuntoProposta;
      }
    },
    fecharModalAceite: function () {
      const self = this;
      self.arquivoAcidente = null;
      self.arquivoRoubo = null;
      self.arquivoAcidenteRoubo = null;
      self.modalAceite.opened = false;
      self.modalAceite.proposta = null;
      self.modalAceite.chkRecusarPropostaRouboValue = false;
      self.modalAceite.processando = false;
      self.modalAceite.datePicker = {
        opened: false,
        dataVigenciaDesejada: null,
        dataVigenciaDesejadaFormatted: null
      };
      self.$refs.datePickerPropostaAssinadaTextField.reset();
    },
    abrirModalBaixarPropostaAssinada: function(conjuntoProposta) {
      const self = this;
      self.modalBaixarPropostaAssinada.opened = true;
      self.modalBaixarPropostaAssinada.proposta = conjuntoProposta;
      self.propostaAssinadaAcidente =
        conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioUm.tipoProposta.id == tipoProposta.ACIDENTE ? conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioUm : null;
      self.propostaAssinadaRoubo = 
        (conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioDois && conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioDois.tipoProposta.id == tipoProposta.ROUBO) ? conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioDois : null;
      self.propostaAssinadaAcidenteRoubo = 
        conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioUm.tipoProposta.id == tipoProposta.ACIDENTE_E_ROUBO ? conjuntoProposta.conjuntoPropostaAssinada.arquivoQuestionarioUm : null;
    },
    fecharModalBaixarPropostaAssinada: function () {
      const self = this;
      self.modalBaixarPropostaAssinada.opened = false;
      self.modalBaixarPropostaAssinada.proposta = null;
      self.modalBaixarPropostaAssinada.processando = false;
      self.propostaAssinadaAcidente = null;
      self.propostaAssinadaRoubo = null;
      self.propostaAssinadaAcidenteRoubo = null;
    },
    copiar: function (selector) {
      const self = this;
      let testingCodeToCopy = document.querySelector(selector)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        document.execCommand('copy');
        self.snackbar.sucesso = true;
        self.snackbar.mensagem = "Copiado com sucesso";
        self.snackbar.visivel = true;
      } catch (err) {
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = "Erro: texto não copiado";
        self.snackbar.visivel = true;
      }
    },
    fecharModalCienciaDeAceitePropostaAssinada: function() {
      const self = this;
      self.modalCienciaDeAceitePropostaAssinada.message = '';
      self.modalCienciaDeAceitePropostaAssinada.conjuntoPropostaAssinada = null;
      self.modalCienciaDeAceitePropostaAssinada.opened = false;
      self.modalCienciaDeAceitePropostaAssinada.processando = false;
    },
    carregaArquivos: function () {
      const self = this;
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaConjuntoArquivo?idQuestionario=${self.model.id}`,
        { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
      .then((response) => {
        self.conjuntoArquivoList = response.data;
      });
    },
    downloadArquivo: function (arquivo) {
        const self = this;
        axios.get(
            `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/downloadArquivo?id=${arquivo.id}&transportadoraNome=${self.$parent.transportadoraModel.nome}`,
            {
              responseType: "blob",
              headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` },
            })
          .then((response) => {
            self.carregaArquivos();
            if (self.permissaoAnalisaSolicitacao) {
                self.$parent.$refs.parecerRef.atualizaStatusList();
                self.$parent.carregaQuestionario();
            }
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
            link.download = response.headers.nomearquivo;
            document.body.appendChild(link)
            link.click();
          })
          .catch((error) => {
            self.snackbar.visivel = true;
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = error.response.data.message;
          })
    },
    arquivoParaByteArray: async function(arquivo) {
      var reader = new FileReader();
      return new Promise((resolve, reject) => {
        var fileByteArray = [];
        reader.readAsArrayBuffer(arquivo);
        reader.onerror = function () {
          reject(null);
        }
        reader.onloadend =  function (evt) {
          if (evt.target.readyState == FileReader.DONE) {
            var arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < array.length; i++) {
              fileByteArray.push(array[i]);
            }
            resolve(fileByteArray);
          }
        }
      });
    },
    fezDownloadDaProposta: function(conjuntoProposta) {
      const self = this;
      if (conjuntoProposta.arquivoQuestionarioUm.visualizacaoCliente && !conjuntoProposta.arquivoQuestionarioDois) {
        return true;
      } else if (conjuntoProposta.arquivoQuestionarioDois) {
        if (conjuntoProposta.arquivoQuestionarioUm.visualizacaoCliente && conjuntoProposta.arquivoQuestionarioDois.visualizacaoCliente) {
          return true;
        } else {
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Erro: operação não é permitida antes de fazer o download da proposta.";
          self.snackbar.visivel = true;
          return false;
        }
      } else {
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = "Erro: operação não é permitida antes de fazer o download da proposta.";
        self.snackbar.visivel = true;
        return false;
      }
    },
    toLocaleDateTimeString: function (val) {
        return CustomFormat.toLocaleDateTimeString(val);
    },
    fecharModalArquivos: function() {
      const self = this;
      self.$refs.formEnvioArquivo.reset();
      self.$refs.formParecer.reset();

      self.arquivoAcidente = null;
      self.arquivoRoubo = null;
      self.arquivoAcidenteRoubo = null;
      self.arquivoPropostaAssinada = null;
      self.descricaoEnvio = '';
      self.parecerEnvio = null;

      self.modalUpload = false;
    },
    resetArquivoModel: function() {
      const self = this;
      self.arquivoModel = {
        descricao: '',
        nomeArquivo: null,
        tipoArquivo: {}, 
        idQuestionario: null,
        tokenUsuario: null,
        mimeType: null,
        downloadLink: null,
        visualizacaoAnalista: false,
        visualizacaoCliente: false
      };
    },
    resetModelConjuntoArquivo: function() {
      self.conjuntoArquivoModel = {
        id: null,
        parecer: null,
        arquivoQuestionarioUm: null,
        arquivoQuestionarioDois: null,
        idQuestionario: 0,
        excluido: false,
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/ArquivosPropostas.vue